export default "__VITE_ASSET__saWe4LXs__"